export const painPoints = [
  { emoji: '✗', text: 'Your dog follows you room to room and can’t switch off.' },
  { emoji: '✗', text: 'You can’t leave for 20 minutes without a camera crisis.' },
  { emoji: '✗', text: 'Neighbors are complaining and your lease feels at risk.' },
  { emoji: '✗', text: 'You’ve tried everything and keep starting over from zero.' },
  { emoji: '✗', text: 'The guilt of leaving feels heavier than staying home.' },
]

export const features = [
  {
    title: 'The Psychology of Silence',
    pain: 'Vol 01',
    description: 'Diagnose your dog’s anxiety type accurately. Understand the mirror effect and why your energy matters.',
  },
  {
    title: 'The De-Trigger Protocol',
    pain: 'Vol 02',
    description: 'Make keys, shoes, bags and coats completely meaningless. Stop the panic before it starts.',
  },
  {
    title: 'The Sanctuary Blueprint',
    pain: 'Vol 03',
    description: 'Turn your home into a calming environment that signals safety even when you are gone.',
  },
  {
    title: 'The Micro-Departure Cycles',
    pain: 'Vol 04',
    description: 'Build real tolerance second by second. The exact training engine with zero guesswork.',
  },
  {
    title: 'The Home Alone Survival Guide',
    pain: 'Vol 05',
    description: 'Handle neighbors, landlords, cameras and long absences without losing your mind or your lease.',
  },
  {
    title: 'The Long-Term Freedom Manual',
    pain: 'Vol 06',
    description: 'Lock in your results. Handle regressions, travel and life changes without starting over.',
  },
]

export const bonuses = [
  {
    emoji: '★',
    tag: 'Bonus 1',
    title: 'The 3AM Panic Guide',
    description: 'A calm, step-by-step protocol for nighttime crisis episodes. Be ready before it happens.',
  },
  {
    emoji: '★',
    tag: 'Bonus 2',
    title: 'The Visual Training Companion',
    description: 'Learn to read your dog’s body language on camera and score sessions like a professional.',
  },
  {
    emoji: '★',
    tag: 'Bonus 3',
    title: 'High-Value Treat Recipe Deck',
    description: '10 simple recipes to make the Calm Zone the most rewarding spot in your home.',
  },
  {
    emoji: '★',
    tag: 'Bonus 4',
    title: 'Neighbor Communication Kit',
    description: 'Done-for-you scripts, notes and templates to handle every complaint professionally.',
  },
  {
    emoji: '★',
    tag: 'Bonus 5',
    title: 'Emergency Professional Help Finder',
    description: 'Know when to get expert help, who to call, and what red flags to never ignore.',
  },
]

export const offerChecklist = [
  'Volume 1: The Psychology of Silence',
  'Volume 2: The De-Trigger Protocol',
  'Volume 3: The Sanctuary Blueprint',
  'Volume 4: The Micro-Departure Cycles',
  'Volume 5: The Home Alone Survival Guide',
  'Volume 6: The Long-Term Freedom Manual',
  'Bonus 1: The 3AM Panic Guide',
  'Bonus 2: The Visual Training Companion',
  'Bonus 3: High-Value Treat Recipe Deck',
  'Bonus 4: Neighbor Communication Kit',
  'Bonus 5: Emergency Professional Help Finder',
]

export const testimonials = [
  {
    quote: 'I went from not being able to leave for 5 minutes to a full 3-hour absence in two weeks. The structure makes all the difference.',
    name: 'Sarah M.',
    role: 'apartment owner',
  },
  {
    quote: 'Volume 2 alone was worth everything. I had no idea the keys were the trigger. Once I fixed that, everything shifted.',
    name: 'James R.',
    role: 'rescue dog parent',
  },
  {
    quote: 'The Neighbor Communication Kit saved my lease. I used the scripts word for word and my landlord actually thanked me for the update.',
    name: 'Mia L.',
    role: 'city apartment dweller',
  },
]

export const faqs = [
  {
    question: 'Is this suitable for all breeds and ages?',
    answer: 'Yes. The CalmPaw™ methodology is based on nervous system regulation, not breed-specific obedience. It works for puppies, adult dogs, and senior dogs across all breeds.',
  },
  {
    question: 'My dog’s anxiety is severe. Will this still work?',
    answer: 'CalmPaw™ includes a severity assessment in Volume 1 and a professional help guide in Bonus 5 for cases that need additional support. Severe cases may benefit from combining the system with veterinary or behavioral consultation.',
  },
  {
    question: 'How long before I see results?',
    answer: 'Most owners report measurable improvement within 7 to 14 days of consistent practice. The system is designed for real life and accounts for setbacks, regressions, and busy schedules.',
  },
  {
    question: 'Is this a physical book or a digital product?',
    answer: 'CalmPaw™ is a digital bundle delivered instantly as downloadable PDF files. No shipping, no waiting. Access everything immediately after purchase.',
  },
  {
    question: 'What if I need help during the process?',
    answer: 'Prof. Kyra’s support email is profkyra@gmail.com. All purchases include direct email support access.',
  },
]
